import { takeLatest, put, call, all, select } from 'redux-saga/effects';
import { getPartnerListWithAccessDetails } from '@api/partner';

import {
  fetchPartnerListWithAccessDetails,
  fetchPartnerListWithAccessDetailsSucceed,
  fetchPartnerListWithAccessDetailsFailed,
  getPartnerState,
} from '@redux/ducks/partner/partner';
import { getUserPermissionsState } from '@redux/ducks/userPermissions/userPermissions';

// Workers

export function* fetchPartnerListTask() {
  try {
    const { searchTerm } = yield select(getPartnerState);
    const { currentApp } = yield select(getUserPermissionsState);

    const response = yield call(getPartnerListWithAccessDetails, {
      access: currentApp.access,
      search: searchTerm,
    });

    yield put(fetchPartnerListWithAccessDetailsSucceed(response));
  } catch (error) {
    yield put(fetchPartnerListWithAccessDetailsFailed(error));
  }
}

// Watchers

export function* watchFetchPartnerList() {
  yield takeLatest([fetchPartnerListWithAccessDetails], fetchPartnerListTask);
}

// Saga

export default function* partnerSaga() {
  yield all([watchFetchPartnerList()]);
}
